export default class ChannelGroupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntitiesByDeviceId(id, params) {
		return this.apiService.callGet('me/channelGroups/' + id, params);
	}

	getEntitiesBySubscriberId(id) {
		return this.apiService.callGet('me/subscriber/channelGroups/' + id);
	}

	getEntity(id) {
		return this.apiService.callGet('me/channelGroup/' + id);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/channelGroup/' + id, {
			name: params.name,
			channel_ids: params.channel_ids,
			device_ids: params.device_ids,
			id_subscriber_profile: params.id_subscriber_profile ? Number(params.id_subscriber_profile) : null,
		});
	}

	resetEntity(id, params) {
		return this.apiService.callPut('me/channelGroup/' + id + '/reset', params);
	}

	createEntity(params){
		return this.apiService.callPost('me/channelGroup', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/channelGroup/' + id, params);
	}

	getBasicDataByIdDevice(idDevice) {
		return this._getBasicData({ id_device: idDevice });
	}

	getBasicDataByIdSubscriber(idSubscriber) {
		return this._getBasicData({ id_subscriber: idSubscriber });
	}

	_getBasicData(params) {
		return this.apiService.callGet('me/channelGroup/basic-data', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/ChannelGroupService.js